var i, len, makeTag, name, ref;

makeTag = function(name, attr, content) {
  var html, key, ref, tail, val;
  if (attr == null) {
    attr = {};
  }
  if (content == null) {
    content = '';
  }
  if (typeof attr === 'string') {
    ref = [{}, attr], attr = ref[0], content = ref[1];
  }
  html = "<" + name;
  tail = "</" + name + ">";
  for (key in attr) {
    val = attr[key];
    key = _.escape(key);
    val = _.escape(String(val));
    html += ' ' + key + '="' + val + '"';
  }
  return html + '>' + content + tail;
};

ref = ['a'];
for (i = 0, len = ref.length; i < len; i++) {
  name = ref[i];
  makeTag[name] = _.partial(makeTag, name);
}

module.exports = makeTag;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9tYWtlVGFnLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvbWFrZVRhZy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxPQUFBLEdBQVUsU0FBQyxJQUFELEVBQU8sSUFBUCxFQUFrQixPQUFsQjtBQUNSLE1BQUE7O0lBRGUsT0FBTzs7O0lBQUksVUFBVTs7RUFDcEMsSUFBaUMsT0FBTyxJQUFQLEtBQWUsUUFBaEQ7SUFBQSxNQUFrQixDQUFDLEVBQUQsRUFBSyxJQUFMLENBQWxCLEVBQUMsYUFBRCxFQUFPLGlCQUFQOztFQUNBLElBQUEsR0FBTyxHQUFBLEdBQUs7RUFDWixJQUFBLEdBQU8sSUFBQSxHQUFNLElBQU4sR0FBWTtBQUNuQixPQUFBLFdBQUE7O0lBQ0UsR0FBQSxHQUFNLENBQUMsQ0FBQyxNQUFGLENBQVMsR0FBVDtJQUNOLEdBQUEsR0FBTSxDQUFDLENBQUMsTUFBRixDQUFTLE1BQUEsQ0FBTyxHQUFQLENBQVQ7SUFDTixJQUFBLElBQVEsR0FBQSxHQUFNLEdBQU4sR0FBWSxJQUFaLEdBQW1CLEdBQW5CLEdBQXlCO0FBSG5DO1NBSUEsSUFBQSxHQUFPLEdBQVAsR0FBYSxPQUFiLEdBQXVCO0FBUmY7O0FBVVY7QUFBQSxLQUFBLHFDQUFBOztFQUFBLE9BQVEsQ0FBQSxJQUFBLENBQVIsR0FBZ0IsQ0FBQyxDQUFDLE9BQUYsQ0FBVSxPQUFWLEVBQW1CLElBQW5CO0FBQWhCOztBQUtBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
